<template>
  <div>
    <Toggle
      v-if="programsData"
      :data="programsData"
      @change-toggle="getSelectedOption"></Toggle>

    <ul v-if="filteredData" class="header__sub__cards__items">
      <li v-for="item in filteredData.programs" :key="item.id">
        <a :href="item.url" class="b-box">
          <div class="b-box__fig">
            <img :src="item.img" alt="" />
          </div>
          <div class="b-box__txt">
            <span>{{ item.label }}</span>
          </div>
        </a>
      </li>
    </ul>

    <a
      v-if="filteredData"
      :href="filteredData.url"
      class="header__sub__cards__lnk">
      {{ filteredData.urlLabel }}
    </a>
  </div>
</template>

<script>
import Toggle from './../components/Toggle.vue'
import * as lib from '../../lib/lib'

export default {
  components: {
    Toggle,
  },

  data() {
    return {
      // default
      programsData: null,
      activeToggle: '',
      filteredData: null,
    }
  },

  mounted() {
    const { data } = lib.getData('toggleMenuData')
    this.programsData = data
  },

  methods: {
    getSelectedOption(opt) {
      this.activeToggle = opt
      this.$nextTick(function () {
        this.fetchFilteredData(this.activeToggle)
      })
    },

    fetchFilteredData(filter) {
      if (this.programsData)
        this.filteredData = this.programsData.find((i) => i.id === filter)
      return this.filteredData
    },
  },
}
</script>
